export default "__VITE_ASSET__89d855ae__"